import type { ShoppingReminder } from '@recipes/contracts';
import { currentFormatLocale } from '@/lib/i18n';

/** A date as the value of a `datetime-local` field: local time, to the minute. */
export function toLocalInput(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** A first proposal: tomorrow at nine, on the minute. */
export function proposal(): string {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  date.setHours(9, 0, 0, 0);
  return toLocalInput(date);
}

export const deviceTimeZone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

/** "Sa., 3.10., 10:00 · wöchentlich · für Anna" – the one line a reminder is shown as. */
export function describeReminder(
  reminder: ShoppingReminder,
  t: (key: string, options?: Record<string, unknown>) => string,
): string {
  const when = new Date(reminder.nextAt ?? reminder.remindAt).toLocaleString(
    currentFormatLocale(),
    { weekday: 'short', day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit' },
  );
  const parts = [when];
  if (reminder.repeat !== 'NONE') parts.push(t(`shopping.reminder.repeat.${reminder.repeat}`));
  if (reminder.assignee)
    parts.push(t('shopping.reminder.for', { name: reminder.assignee.displayName }));
  return parts.join(' · ');
}
